export class SideNavTextDataEN {
    static readonly htmlLabel = {
        appName: 'PREP',
        ariaMainNav: 'Main navigation menu',
        ariaGoDashboard: 'Go to dashboard page',
        ariaExpandMenu: 'Expand sidebar menu',
        ariaCollapseMenu: 'Collapse sidebar menu',

    };
    static readonly snackbarLabel = {
        signedOut: 'Signed out.',
        welcomeMyProfile: 'Welcome to My Profile!',
        welcomeDashboard: 'Welcome to Dashboard!',
    };
    static readonly tooltipLabel = {
        userProfileText: 'Profile',
        userLogoutText: 'Sign out',

    }
    static readonly menuLabel = {

        menuDashboard: 'Dashboard',
        menuUploadFile: 'Upload File',
        menuExport: 'Exports',
        menuReport: 'Reports',
        menuHeaderAdminTool: 'ADMIN TOOL',
        menuFileUploadUsage: 'File Upload Usage',
        menuAPIUsage: 'API Usage',
        menuAccountConfig: 'Account Config',
        menuTemplateConfig: 'Template Config',
        menuExternalUsage: 'External Usage',
        menuHeaderCEAdmin: 'CE ADMIN',
        menuHeaderCanvasIntegration: 'CANVAS INTEGRATION',
        menuCanvasLMSFiles: 'Canvas LMS Files',
        menuHeaderCivicPlusIntegration: 'CIVIC PLUS INTEGRATION',
        menuCivicPlusFiles: 'CivicPlus Files',
        menuHeaderCivicPlusV2Integration: 'CIVIC PLUS INTEGRATION',
        menuCivicPlusV2Files: 'CivicPlus Files',
        MenuHeaderRemediationServices: 'REMEDIATION SERVICES',
        MenuHeaderBlackboardIntegration: 'BLACKBOARD INTEGRATION',
        menuBlackboardFiles: 'Blackboard Files',
        MenuHeaderWordpressIntegration: 'WORDPRESS INTEGRATION',
        menuWordpressFiles: 'Wordpress Files',
        menuOrder: 'Orders',
        menuTransactions: 'Transactions',
        MenuHeaderD2lIntegration: 'D2L INTEGRATION',
        menuD2lLMSFiles: 'D2L LMS Files',
        MenuHeaderD2lApiIntegration: 'D2L INTEGRATION',
        menuD2lApiFiles: 'D2L Files',
        MenuHeaderRSPAdministration: 'RSP SERVICE ADMIN',
        menuCEOrders: 'CE Orders',
        menuUsageDashboard: 'Usage Dashboard',
        menuUsers: 'Users',
        menuCEUserNotificationUser: 'CE User Notification',
        menuExternalContact: 'External Contact'
    };
}
